module.exports = __webpack_public_path__ + "static/media/goldenbeige.aa2f6f5b.png";